export default __webpack_public_path__ + "static/media/gsap_icon.ded539f7.webp";